import {Component, ElementRef, OnInit} from '@angular/core';
import {BaseRendererComponent} from "../base-renderer/base-renderer.component";
import {ViewMode} from "../../../models/type/view-mode.enum";
import {UserService} from "../../../services/user/user.service";
import {InternationalizationService} from "../../../services/internationalization/internationalization.service";

@Component({
  selector: 'sb-datetime-renderer',
  templateUrl: './datetime-renderer.component.html',
  styleUrls: ['./datetime-renderer.component.scss']
})
export class DateTimeRendererComponent extends BaseRendererComponent implements OnInit {

  constructor(private hostElement: ElementRef<HTMLElement>,
              private userService: UserService,
              private i18nService: InternationalizationService) {
    super();
  }

  ngOnInit(): void {
  }

  dateValue() {
    const value = this.fieldValue(); // ISO string
    return new Date(value);
  }

  dateFormat() {
    return this.i18nService.getLongDateTimeFormatCLDR();
  }

  enabled() {
    return !(this.elementOrViewModeReadOnly());
  }

  readOnlyDateValue() {
    const value = this.fieldValue(); // ISO string
    const date = new Date(value);
    return this.i18nService.formatLongDateTime(date);
  }

}
